import antLocale from 'ant-design-vue/es/locale-provider/ja_JP'
import 'moment/locale/ja'
import setting from './ja-JP/setting'
import ui from './ja-JP/messages.json'

export default { antLocale, momentName: 'ja', message: '-', ...setting, ui }
